module.exports = {
	"articleTitle1": "Festival Report: Electric Forest 2016 ",
	"catImage": "bluestar.png",
	"totalCats": 1,
	"name": "Electrical & Computer Engineering Building",
	"articleLink1": "https://www.michigandaily.com/section/arts/festival-report-electric-forest-2016",
	"articleLink2": "https://www.michigandaily.com/arts/electric-forest-decadent-not-depraved",
	"articleSnippet1": "Jul 11, 2016 ... An interesting phenomenon occurs when the crowd is equally, if not more, \ncaptivating than the act itself. At Electric Forest I found my eyes, ...",
	"articleSnippet2": "Jul 2, 2014 ... Electric Forest is not so much a music festival as it is a four day act of collective \nweirdness, heavily facilitated by the festival organizers and ...",
	"totalMisc": 0,
	"articleTitle2": "Electric Forest is Decadent, but not Depraved",
	"address": "1301 Beal Ave. Ann Arbor, MI",
	"images": [],
	"position": {
		"lat": 42.292323,
		"lng": -83.71321
	},
	"tips": [
		{
			"text": "Many of the class rooms are empty and open, so they make for a good place to do some group work, especially on weekends.",
			"person": "Nick Kortman"
		},
		{
			"text": "Check out the DB cafe for very cheap snacks.",
			"peson": "Bob Lesser"
		}
	],
	"bathroomrating": [
		{
			"rating": 3,
			"bathroom": "1st Floor"
		}
	],
	"categories": {
		"academics": 1,
		"universitybuilding": 1,
		"location": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/eecsbuilding.json
// module id = 871
// module chunks = 0